import { plural } from "@/lib/utils";
import { useCountdown } from "./use-countdown";
import { cx } from "class-variance-authority";

interface CountdownProps {
  targetDate: number;
  offset?: number;
  onExpire?: () => void;
}

export default function Countdown({ targetDate, offset, onExpire }: CountdownProps) {
  const timeLeft = useCountdown(targetDate, offset);

  // Call onExpire when countdown finishes
  if (timeLeft.isExpired && onExpire) {
    onExpire();
  }

  return (
    <div className="bg-background rounded-lg border p-6 flex items-center justify-center gap-2 sm:gap-3 md:gap-4">
      {!timeLeft.days ? null : (
        <>
          <div className="bg-card text-card-foreground px-4 py-2 rounded-md flex flex-col items-center justify-center border w-20 h-20">
            <div className="text-2xl font-bold">
              {String(timeLeft.days).padStart(2, "0")}
            </div>
            <div className="text-sm text-muted-foreground">
              {plural("Day", timeLeft.days)}
            </div>
          </div>
          <span className="text-2xl font-bold flex text-primary">:</span>
        </>
      )}
      <div className="bg-card text-card-foreground px-4 py-2 rounded-md flex flex-col items-center justify-center border w-20 h-20">
        <div className="text-2xl font-bold">
          {String(timeLeft.hours).padStart(2, "0")}
        </div>
        <div className="text-sm text-muted-foreground">
          {plural("Hour", timeLeft.hours)}
        </div>
      </div>
      <span className="text-2xl font-bold text-primary">:</span>
      <div className="bg-card text-card-foreground px-4 py-2 rounded-md flex flex-col items-center justify-center border w-20 h-20">
        <div className="text-2xl font-bold">
          {String(timeLeft.minutes).padStart(2, "0")}
        </div>
        <div className="text-sm text-muted-foreground">
          {plural("Minute", timeLeft.minutes)}
        </div>
      </div>
      <span
        className={cx(
          "text-2xl font-bold text-primary flex xl:flex",
          timeLeft.days ? "hidden" : ""
        )}
      >
        :
      </span>
      <div
        className={cx(
          "bg-card text-card-foreground px-4 py-2 rounded-md flex xl:flex flex-col items-center justify-center border w-20 h-20",
          timeLeft.days ? "hidden" : ""
        )}
      >
        <div className="text-2xl font-bold">
          {String(timeLeft.seconds).padStart(2, "0")}
        </div>
        <div className="text-sm text-muted-foreground">
          {plural("Second", timeLeft.seconds)}
        </div>
      </div>
    </div>
  );
}
